import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';

//Servicios
import { DJCEService } from '../../services/api';

//Modelos
import NewDJCEModel from '../../models/NewDJCE';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import NewDJCE from './NewDJCE';
import Modal from '../../components/modal/Modal';

function NewDJCEContainer() {
    const { toast, token, user, masters, grapesVariety, buildSelectOptions } =
        useGlobalContext();

    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [OpenFirmaModal, setOpenFirmaModal] = useState(false);
    const [OpenVistoModal, setOpenVistoModal] = useState(false);
    const [OpenInhabilitarModal, setOpenInhabilitarModal] = useState(false);
    const [DJCEData, setDJCEData] = useState(new NewDJCEModel());

    const FormMethods = useForm();

    const DJCECerrada = useMemo(() => {
        return DJCEData.declaracion?.fecha_Cierre !== null && user.tipo !== 3;
    }, [DJCEData]);

    const FirmarModalMessage = (
        <div className="new_guia-modal-div">
            {user.tipo !== 3 ? (
                <p>
                    Al firmar, usted está cerrando el ingreso de datos para la
                    DJCE.
                </p>
            ) : (
                <p>Al firmar, usted está habilitando esta DJCE.</p>
            )}
            {
                <label className="new_guia-label">
                    <div>
                        <span>Tipo Documento: </span>
                        <select
                            {...FormMethods.register(
                                user.tipo !== 3
                                    ? 'djce.doc_id_tipo_Viticultor'
                                    : 'djce.doc_id_tipo_Funcionario'
                            )}
                        >
                            {buildSelectOptions('DocumentTypes')?.map((op) => {
                                return (
                                    <option key={op.name} value={op.value}>
                                        {op.title}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </label>
            }
            <label className="new_guia-label">
                <div>
                    <span>Nro de Documento: </span>
                    <input
                        className="signup-input"
                        type="text"
                        {...FormMethods.register(
                            user.tipo !== 3
                                ? 'djce.doc_id_Viticultor'
                                : 'djce.doc_id_Funcionario',
                            {
                                required: {
                                    value: OpenFirmaModal,
                                    message:
                                        'Debe ingresar número de documento',
                                },
                            }
                        )}
                        onKeyPress={(e) => {
                            if (
                                !/[A-Za-z0-9]+/.test(e.key) ||
                                e.target.value.length > 15
                            ) {
                                e.preventDefault();
                            }
                        }}
                    />
                </div>
                {FormMethods.formState.errors.declaracion
                    ?.doc_id_Destinatario && (
                    <small className="form__error">
                        {
                            FormMethods.formState.errors.declaracion
                                ?.doc_id_Destinatario?.message
                        }
                    </small>
                )}
            </label>
            <label className="new_guia-label">
                <div>
                    <span>
                        {user.tipo !== 3
                            ? 'Firma Vitivinicultor'
                            : 'Firma Funcionario'}
                        :{' '}
                    </span>
                    <input
                        type="text"
                        {...FormMethods.register(
                            user.tipo !== 3
                                ? 'djce.firma_Viticultor'
                                : 'djce.firma_Funcionario',
                            {
                                required: {
                                    value: OpenFirmaModal,
                                    message: 'Debe firmar la guía',
                                },
                            }
                        )}
                        onKeyPress={(e) => {
                            if (e.target.value.length > 60) {
                                e.preventDefault();
                            }
                        }}
                    />
                </div>
                {FormMethods.formState.errors.declaracion?.firma_Viticultor && (
                    <small className="form__error">
                        {
                            FormMethods.formState.errors.declaracion
                                ?.firma_Viticultor?.message
                        }
                    </small>
                )}
            </label>
            <footer>
                <button
                    className="btn btn-primary"
                    onClick={FormMethods.handleSubmit(onSubmit)}
                >
                    Firmar
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => setOpenFirmaModal(false)}
                >
                    Cancelar
                </button>
            </footer>
        </div>
    );

    const VistoModalMessage = (
        <div className="DJCE_visto-modal">
            <footer>
                <button className="btn btn-primary" onClick={onSubmitVisto}>
                    Aceptar
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => setOpenVistoModal(false)}
                >
                    Cancelar
                </button>
            </footer>
        </div>
    );

    const InhabilitarModalMessage = (
        <div className="DJCE_visto-modal">
            <footer>
                <button
                    className="btn btn-primary"
                    onClick={onSubmitInhabilitar}
                >
                    Aceptar
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => setOpenInhabilitarModal(false)}
                >
                    Cancelar
                </button>
            </footer>
        </div>
    );

    useEffect(() => {
        async function fetchDJCE() {
            try {
                setLoader(true);
                //Obtenemos la DJCE segun el id de los params
                const DJCE = await DJCEService.single({
                    token,
                    id: parseInt(Params.id),
                });
                if (DJCE) {
                    //Establecemos los datos para la nueva DJCE
                    const newDJCE = new NewDJCEModel(DJCE.data);
                    setDJCEData(newDJCE);
                    //Establecemos los valores iniciales del form
                    newDJCE.declaracion.titulares_Documento =
                        newDJCE.declaracion.titulares_Documento?.split(' / ');
                    // FormMethods.reset({ ...newDJCE });
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        }
        fetchDJCE();
    }, []);

    async function onSubmit(data) {
        try {
            setLoader(true);
            //Formacion del objeto para enviar en la peticion
            // console.log(data);
            if (user.tipo !== 3) {
                data.djce.doc_id_tipo_Viticultor = parseInt(
                    data.djce.doc_id_tipo_Viticultor
                );
            }
            if (user.tipo === 3) {
                data.djce.doc_id_tipo_Funcionario = parseInt(
                    data.djce.doc_id_tipo_Funcionario
                );
            }

            //Peticion para actualizar la DJCE
            const UpdateDJCE = await DJCEService.update({
                token,
                djce: {
                    id: Params.id,
                    ...data.djce,
                },
            });

            //Si la respuesta es correcta, navegamos denuevo a la tabla de DJCEs y desplegamos mensaje de éxito
            if (UpdateDJCE) {
                user.tipo !== 3
                    ? Navigate(RoutesApp.Declaraciones.cosechaEfectiva)
                    : Navigate(RoutesApp.Home);
                toast('DJCE enviada con éxito', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    }

    async function onSubmitVisto() {
        try {
            const DJCEVista = await DJCEService.update({
                token,
                djce: {
                    id: Params.id,
                    vista_Id_Funcionario: user.id,
                },
            });

            if (DJCEVista) {
                Navigate(RoutesApp.Home);
                toast('DJCE procesada con éxito', { type: 'success' });
            }
        } catch (err) {
            return err;
        }
    }

    async function onSubmitInhabilitar() {
        try {
            const DJCEVista = await DJCEService.update({
                token,
                djce: {
                    id: Params.id,
                    habilitada: 1,
                },
            });

            if (DJCEVista) {
                Navigate(RoutesApp.Home);
                toast('DJCE inhabilitada con éxito', { type: 'success' });
            }
        } catch (err) {
            return err;
        }
    }

    return loader ? (
        <Spinner />
    ) : (
        <>
            <NewDJCE
                functions={{
                    ...FormMethods,
                    onSubmit,
                    setOpenFirmaModal,
                    setOpenVistoModal,
                    setOpenInhabilitarModal,
                }}
                states={{ user, masters, grapesVariety, DJCEData, DJCECerrada }}
            />
            <Modal
                title={'Firmar DJCE'}
                isOpen={OpenFirmaModal}
                onClose={() => setOpenFirmaModal(!OpenFirmaModal)}
                questionModal
            >
                {FirmarModalMessage}
            </Modal>
            <Modal
                title={'¿Esta seguro que desea aprobar la DJCE?'}
                isOpen={OpenVistoModal}
                onClose={() => setOpenVistoModal(!OpenVistoModal)}
                questionModal
            >
                {VistoModalMessage}
            </Modal>
            <Modal
                title={'¿Esta seguro que desea inhabilitar la DJCE?'}
                isOpen={OpenInhabilitarModal}
                onClose={() => setOpenInhabilitarModal(!OpenInhabilitarModal)}
                questionModal
            >
                {InhabilitarModalMessage}
            </Modal>
        </>
    );
}

export default NewDJCEContainer;
